import { css } from '@/styled-system/css';

// Filled white circle with shadow so the buttons read clearly against listing
// photos / busy carousel backgrounds. Constellation's bare `tone="neutral"
// emphasis="filled"` defaults blend into the page background for our use case.
// Keep buttons inside the carousel so the nav affordance cannot widen the document.
export const prevButton = css({
  position: 'absolute',
  bottom: '50%',
  zIndex: 1,
  background: 'bg.neutral',
  boxShadow: 'md',
  transform: 'translate3d(0, 50%, 0)',
  _hover: { background: 'bg.softest' },
  left: '0',
});

export const nextButton = css({
  position: 'absolute',
  bottom: '50%',
  zIndex: 1,
  background: 'bg.neutral',
  boxShadow: 'md',
  transform: 'translate3d(0, 50%, 0)',
  _hover: { background: 'bg.softest' },
  right: '0',
});

// Shared because a placeholder only reserves the right height when it is exactly
// as wide as the card replacing it — the card's photo is a 4:3 box.
export const carouselItem = css({
  flexShrink: 0,
  // eslint-disable-next-line hotpads/no-magic-numbers, constellation/no-raw-spacing-values -- matches established ListingCarousel card rhythm
  width: '280px',
  sm: {
    // eslint-disable-next-line hotpads/no-magic-numbers, constellation/no-raw-spacing-values -- matches established ListingCarousel card rhythm
    width: '300px',
  },
  md: {
    // eslint-disable-next-line hotpads/no-magic-numbers, constellation/no-raw-spacing-values -- matches established ListingCarousel card rhythm
    width: '340px',
  },
});
